'use client'
import { useEffect } from 'react'
/**
 * Adds `data-theme="15"` to <html> and sets body background to #FAF7F2
 * so there's no white/gray shade gap next to the browser scrollbar.
 * Cleans up on unmount (when navigating away from Theme 15).
 */
export default function Theme15ScrollbarInit() {
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', '15')
        const originalBg = document.body.style.backgroundColor
        document.body.style.backgroundColor = '#FAF7F2'
        return () => {
            document.documentElement.removeAttribute('data-theme')
            document.body.style.backgroundColor = originalBg
        }
    }, [])

    return null
}
